var map = {
	"./404/empty-box.svg": 8772,
	"./atendimento/1.png": 7304,
	"./campanhas/img-banner-principal.svg": 7393,
	"./checkout/card-brands.png": 7971,
	"./empresa/point-bg.png": 9811,
	"./loading/loading.gif": 1516,
	"./logo-dpc-green.svg": 702,
	"./logoDPC-mobile.png": 7875,
	"./logoDPC.svg": 2095,
	"./no-logo.svg": 2863,
	"./pagamento/amex.png": 9386,
	"./pagamento/barCode.svg": 5855,
	"./pagamento/box.svg": 8449,
	"./pagamento/cardIcon.svg": 6437,
	"./pagamento/elo.png": 4062,
	"./pagamento/hipercard.png": 1367,
	"./pagamento/local.svg": 592,
	"./pagamento/mastercard.png": 1695,
	"./pagamento/nota.svg": 8891,
	"./pagamento/visa.png": 3759,
	"./payment-methods.png": 9671,
	"./percent.svg": 3181,
	"./produtos/detalhes-produto/forklift.png": 3165,
	"./produtos/detalhes-produto/open-box.png": 7207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;